/* @flow */
/* eslint import/no-commonjs: off */

// $FlowFixMe
module.exports = require('./dist/checkout.lib');

module.exports.default = module.exports;
